import { DateTime } from "luxon";
import { useEffect, useMemo, useState, type FC, type ReactNode } from "react";
import { TimestampContext } from "./timestampContext.js";

// Refresh relative timestamps in the UI every 60 seconds
const refreshInterval = 60_000;

export const TimestampProvider: FC<{ children: ReactNode }> = (props) => {
  const [now, setNow] = useState(() => DateTime.now());

  useEffect(() => {
    const handle = setInterval(() => {
      setNow(DateTime.now());
    }, refreshInterval);

    return () => {
      clearInterval(handle);
    };
  }, []);

  const value = useMemo(() => ({ now }), [now]);

  return (
    <TimestampContext.Provider value={value}>
      {props.children}
    </TimestampContext.Provider>
  );
};
